import {
  FEATURE_COOKIE,
  FLOW_PAYMENT_MANDATORY_FROM,
  FLOW_PAYMENT_ROLLOUT_RATE,
  FLOW_COOKIE_MAX_AGE_SECONDS,
} from '../constants/constants';
import * as utils from './OrderUtils';

function isFlowPaymentMandatoryFromDate(now = Date.now()) {
  if (!FLOW_PAYMENT_MANDATORY_FROM) {
    return false;
  }

  const cutoff = Date.parse(`${FLOW_PAYMENT_MANDATORY_FROM}T00:00:00Z`);
  if (Number.isNaN(cutoff)) {
    return false;
  }

  return now >= cutoff;
}

function assignFlowPaymentCookie() {
  const key = FEATURE_COOKIE.FLOW_PAYMENT;
  const value = Math.random() < FLOW_PAYMENT_ROLLOUT_RATE ? '1' : '0';
  document.cookie = `${key}=${value};path=/;SameSite=Lax;max-age=${FLOW_COOKIE_MAX_AGE_SECONDS}`;
  return value;
}

function resolveFlowPaymentCookieValue() {
  const key = FEATURE_COOKIE.FLOW_PAYMENT;
  const existing = utils.getCookieValue(key);

  if (existing === '1' || existing === '0') {
    return existing;
  }

  return assignFlowPaymentCookie();
}

/**
 * Returns whether the Flow payment UI should be used.
 * Before the mandatory date this may assign and persist the rollout cookie
 * when the cookie is missing or invalid.
 */
function isFlowPaymentEnabled() {
  if (isFlowPaymentMandatoryFromDate()) {
    return true;
  }

  return resolveFlowPaymentCookieValue() === '1';
}

export default isFlowPaymentEnabled;
